/**
* DevExpress Analytics (query-builder\wizard\pages\wizardPage.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var utils_1 = require("../../../serializer/utils");
var WizardPageBase = (function (_super) {
    __extends(WizardPageBase, _super);
    function WizardPageBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onChange = function () { return void 0; };
        return _this;
    }
    WizardPageBase.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this._onChange = function () { return void 0; };
    };
    WizardPageBase.prototype.commit = function () {
        return $.Deferred().resolve().promise();
    };
    WizardPageBase.prototype.onChange = function (callback) {
        this._onChange = callback;
    };
    WizardPageBase.prototype.initialize = function (state) {
        return $.Deferred().resolve().promise();
    };
    WizardPageBase.prototype.canNext = function () {
        return true;
    };
    WizardPageBase.prototype.canFinish = function () {
        return false;
    };
    return WizardPageBase;
}(utils_1.Disposable));
exports.WizardPageBase = WizardPageBase;
var _WrappedWizardPage = (function (_super) {
    __extends(_WrappedWizardPage, _super);
    function _WrappedWizardPage(pageId, page, template, description) {
        var _this = _super.call(this) || this;
        _this.pageId = pageId;
        _this.page = page;
        _this.template = template;
        _this.description = description;
        _this._isInitialized = false;
        _this._initDef = null;
        _this.isChanged = true;
        if (page.onChange) {
            _this.onChange = function (callback) { return page.onChange(callback); };
        }
        return _this;
    }
    _WrappedWizardPage.prototype.dispose = function () {
        this.onChange = null;
        this[wizard_1.BaseWizard.__loadingStateFunctionName] = null;
        this.page.dispose();
        this._initDef && this._initDef.reject();
        this._initDef = null;
    };
    _WrappedWizardPage.prototype.resetCommitedState = function () {
        this._lastCommitedState = null;
    };
    _WrappedWizardPage.prototype.commit = function () {
        var _this = this;
        return this.page.commit().done(function (result) {
            _this.isChanged = JSON.stringify(_this._lastCommitedState) !== JSON.stringify(result);
            _this._lastCommitedState = result;
        });
    };
    _WrappedWizardPage.prototype.initialize = function (state, force) {
        var _this = this;
        if (force === void 0) { force = false; }
        this._initDef && this._initDef.reject();
        this._initDef = $.Deferred();
        if (!this._isInitialized || force) {
            this._isInitialized = true;
            this.page.initialize(state).fail(function () {
                _this._isInitialized = false;
                _this._initDef && _this._initDef.reject();
            }).done(function (result) {
                _this._initDef && _this._initDef.resolve(result);
            });
        }
        else {
            this._initDef.resolve();
        }
        return this._initDef.promise();
    };
    return _WrappedWizardPage;
}(utils_1.Disposable));
exports._WrappedWizardPage = _WrappedWizardPage;
var wizard_1 = require("../wizard");
